import {
  TFormFieldsAndRules as TBaseFormFieldsAndRules,
  getFieldInfoByFieldName as getFieldInfoByFieldNameCommon,
  getFieldsNamesFromFieldsAndRules as getFieldsNamesFromFieldsAndRulesCommon,
  getFieldsRules as getFieldsRulesCommon,
} from '@componentsroot/Form/FormGenerator/common';
import { TFromFieldInfo, TRules } from '@componentsroot/Form/FormGenerator/utils';

export type TFormFieldsAndRulesRow<T = any> = {
  fields: TFromFieldInfo<T>[];
  RowContainer?: React.ComponentType<{ children: React.ReactNode }>;
};

export type TFormFieldsAndRules<TFieldName = string> = {
  [rows: string]: TFormFieldsAndRulesRow<TFieldName>;
};

function convertToBaseFormFieldsAndRules<TFieldName = string>(
  formFieldsAndRules: TFormFieldsAndRules<TFieldName>,
): TBaseFormFieldsAndRules<TFieldName> {
  return Object.entries(formFieldsAndRules).reduce((acc, [rowKey, rowValue]) => {
    acc[rowKey] = rowValue.fields;
    return acc;
  }, {} as TBaseFormFieldsAndRules<TFieldName>);
}

export function getFieldsRules<TFieldName = string>(
  formFieldsAndRules?: TFormFieldsAndRules<TFieldName>,
  prefix?: keyof typeof formFieldsAndRules,
): TRules {
  // TODO: processing prefix situation ?

  return getFieldsRulesCommon(convertToBaseFormFieldsAndRules(formFieldsAndRules), prefix);
}

export function getFieldsNamesFromFieldsAndRules(
  formFieldsAndRules?: TFormFieldsAndRules,
): string[] {
  return getFieldsNamesFromFieldsAndRulesCommon(
    convertToBaseFormFieldsAndRules(formFieldsAndRules),
  );
}

export function getFieldInfoByFieldName(
  fieldsAndRules: TFormFieldsAndRules,
  fieldName: string,
): TFromFieldInfo {
  return getFieldInfoByFieldNameCommon(convertToBaseFormFieldsAndRules(fieldsAndRules), fieldName);
}
